const LISTE_PRODUIT_RESEAU_NUMERIQUE = {
  title: 'Liste des produits réseau numérique',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des produits réseau numérique',
  },
  actions: {
    add: 'Nouveau produit réseau numérique',
  },
  tabs: {
    reference: 'Référence',
    libelle: 'Libellé',
    ville: 'Ville',
    format: 'Format',
    type: 'Type',
    nbEcran: 'Nb d\'écrans',
    agence: 'Agence',
    societe: 'Société',
    actif: 'Archivé',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    dateVisualisation: 'Date de visualisation',
    reference: 'Référence',
    libelle: 'Libellé',
    actif: 'Actif',
    ville: 'Ville(s)',
    departement: 'Département(s)',
    format: 'Format(s)',
    type: 'Type(s) de réseau',
    societe: 'Société',
    agence: 'Agence',
    yes: 'Oui',
    no: 'Non',
    errors: {
      dateVisualisation: 'La date de visualisation est obligatoire',
    },
  },
  archivage: {
    archiver: 'Etes-vous sûr de vouloir archiver ce produit ?',
    desarchiver: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    sucessArchivage: 'Produit archivé avec succès',
    successDesarchivage: 'Produit désarchivé avec succès',
  },
  messageErrorCleApiEdition: 'Votre clé API Google est invalide.',
};

export default LISTE_PRODUIT_RESEAU_NUMERIQUE;
